import { Mail, Phone, MapPin, Facebook, Instagram } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Shared Contact dialog. Mirrors the one originally embedded in HomePage
 * so any page can offer a "Contact Us" trigger without duplicating markup.
 */
const ContactUsDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#121212] text-white max-w-md">
      <DialogHeader>
        <DialogTitle className="text-2xl font-black tracking-tighter">
          Contact <span className="text-[#8cc63f]">Assenda</span>
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4 mt-2 text-sm">
        <a
          href="mailto:assendaevents@gmail.com"
          data-testid="contact-email"
          className="flex items-center gap-3 p-3 rounded-sm border border-white/10 hover:border-[#8cc63f] transition-colors"
        >
          <Mail size={18} className="text-[#8cc63f]" />
          <div>
            <p className="label-text">Email</p>
            <p className="font-semibold">assendaevents@gmail.com</p>
          </div>
        </a>
        <a
          href="tel:+639989892051"
          data-testid="contact-phone"
          className="flex items-center gap-3 p-3 rounded-sm border border-white/10 hover:border-[#8cc63f] transition-colors"
        >
          <Phone size={18} className="text-[#8cc63f]" />
          <div>
            <p className="label-text">Phone</p>
            <p className="font-semibold">+63 998 989 2051</p>
          </div>
        </a>
        <a
          href="https://maps.app.goo.gl/DaeCFPcwCp4xvnci6"
          target="_blank"
          rel="noreferrer"
          data-testid="contact-location"
          className="flex items-center gap-3 p-3 rounded-sm border border-white/10 hover:border-[#8cc63f] transition-colors"
        >
          <MapPin size={18} className="text-[#8cc63f]" />
          <div>
            <p className="label-text">Location</p>
            <p className="font-semibold">
              Centennial Road, Tabon 1, Kawit, Cavite, Philippines
            </p>
            <p className="text-xs text-[#a1a1aa] mt-0.5">
              Kindly use this pin on Google Maps or Waze:{" "}
              <span className="text-[#8cc63f]">📍 Assenda Kawit</span>
            </p>
          </div>
        </a>
        <div className="flex gap-3 pt-2">
          <a
            href="https://web.facebook.com/profile.php?id=61577817171416"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-facebook"
            className="flex-1 inline-flex items-center justify-center gap-2 py-2 border border-white/10 rounded-sm hover:border-[#8cc63f] hover:text-[#8cc63f] transition-colors"
          >
            <Facebook size={16} /> Facebook
          </a>
          <a
            href="https://www.instagram.com/assendaph/?hl=en"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-instagram"
            className="flex-1 inline-flex items-center justify-center gap-2 py-2 border border-white/10 rounded-sm hover:border-[#8cc63f] hover:text-[#8cc63f] transition-colors"
          >
            <Instagram size={16} /> Instagram
          </a>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default ContactUsDialog;
